import React from 'react';
import {
  Container, Dimmer, Table, Card,
  Button, Page
} from "tabler-react";

const RecordsTable = ({
  headers,
  records,
  openMainModal,
  loading,
  reload
}) => {

  return (
    <Container>
      <Page.Header>
        <Page.Title>Pricing</Page.Title>
      </Page.Header>
      <Card>
        <Dimmer active={loading} loader={loading}>
          <Card.Header>
            <Card.Options>
              <Button
                icon="plus"
                color="primary"
                size="md"
                onClick={() => openMainModal('pricing-create', null, reload)}
              >
                Create Price
              </Button>
            </Card.Options>
          </Card.Header>

          {!loading && records.length < 1 ? (
            <div className="alert alert-primary m-0">
              No Pricing to show!
            </div>
          ) : (
            <div className="table-responsive-wrapper">
              <Table hasOutline striped>
                <Table.Header>
                  {headers.map((head, i) => (
                    <Table.ColHeader key={`tableHeader-${i}`}>
                      {head}
                    </Table.ColHeader>
                  ))}
                  <Table.ColHeader>Actions</Table.ColHeader>
                </Table.Header>
                <Table.Body>
                  {records.map((r, i) => (
                    <Table.Row key={i}>
                      {Object.keys(r).map((k, idx) => {
                        if (k === 'id') { return null }
                        else {
                          return (<Table.Col key={`${i}-${k}`}>{r[k]}</Table.Col>);
                        }
                      })}
                      <Table.Col>
                        <div className="actions-wrap">
                          <Button
                            outline
                            color="secondary"
                            size="sm"
                            onClick={() => openMainModal('pricing-edit', r.id, reload)}
                          >
                            Edit
                          </Button>

                          <Button
                            outline
                            color="danger"
                            className="ml-2"
                            size="sm"
                            onClick={() => openMainModal('prices--delete', r['id'], reload)}
                          >
                            Delete
                          </Button>
                        </div>
                      </Table.Col>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Dimmer>
      </Card>
    </Container>
  );
}

export default RecordsTable;